










































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { SignInData } from '@/interfaces/UserInterfaces'
import { AxiosResponse } from 'axios'
import UserService from '@/services/UserService'
import LocaleHelper from '@/utils/LocaleHelper'
import { EventBus } from '@/main'
import SurveyHelper from '@/utils/SurveyHelper'

@Component({ name: 'SignInForm' })
export default class SignInForm extends Vue {
  @Prop({ default: '' })
  surveyProduct?: string

  @Prop({ default: '' })
  accessCode?: string

  signInData: SignInData = {
    candidateNumber: null,
    password: ''
  }
  error: string = ''
  rememberMe: Boolean = false

  async submit () {
    if (!await this.$validator.validateAll()) {
      return
    }

    try {
      if (this.surveyProduct === SurveyHelper.TS && this.accessCode) {
        this.signInData = { ...this.signInData, accessCode: this.accessCode }
      }

      await this.$auth.login(this.signInData)
      await UserService.completeLogin()

      const userLocale = LocaleHelper.getUserLocale()
      if (userLocale) {
        this.localizeValidator(LocaleHelper.getLocaleForVeeValidate(userLocale))
      }

      this.$validator.reset()
      this.error = ''
    } catch (error) {
      const response: AxiosResponse = error.response
      if (response) {
        this.error = response.data.message || response.data.error || 'Sign in error'
      } else {
        throw error
      }
    }
  }

  changeForm (formName: string) {
    this.$emit('changeForm', formName)
  }

  resetPassword () {
    this.$router.push({ name: 'requestResetPassword' })
  }
}
